import React from 'react'

function Header() {
  return (
    <nav className="navbar header">
      <h1 className='header-h1'>NavEq<sub className='header-sub'>for SRIT</sub></h1>
    </nav>
  )
}
export default Header